import styles from "./styles.module.css";

interface PopupProps {
  message: string;
  redText: string;
  bottomMessage: string;
  btnTexts: string[];
  onClickBtn: (text: string) => void;
}
const BvnValidationErrorPopup: React.FC<Partial<PopupProps>> = ({
  message,
  redText,
  btnTexts,
  bottomMessage,
  onClickBtn,
}) => {
  return (
    <div className={styles.popupWrapper}>
      <p className={styles.message}>
        {message}
        {redText && (
          <>
            <br /> <br /> <span className="text-danger fw-bold">{redText}</span>
          </>
        )}
      </p>
      {bottomMessage && (
        <p className={`${styles.message} ${styles.bottomMessage}`}>
          {bottomMessage}
        </p>
      )}
      <div className={styles.btnTexts}>
        {btnTexts?.map((text, index) => (
          <button
            key={text}
            className={`${styles[index === 0 ? "whiteBtn" : "coloredBtn"]}`}
            onClick={() => onClickBtn && onClickBtn(text)}
          >
            {text}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BvnValidationErrorPopup;
